import {UserGroupsComponent} from './user-groups.component';
import {UserGroupsListComponent} from './user-groups-list/user-groups-list.component';
import {UserGroupsConditionsComponent} from './user-groups-conditions/user-groups-conditions.component';
import {UserGroupsDetailComponent} from './user-groups-detail/user-groups-detail.component';
import {UserGroupsPropertiesComponent} from './user-groups-properties/user-groups-properties.component';
import {UserGroupsSpecificUserComponent} from './user-groups-specific-user/user-groups-specific-user.component';
import {UserGroupsService} from './user-groups.service';
import {StoreModule} from '@ngrx/store';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SharedModule} from '../../shared/shared.module';
import {UserGroupsPropertiesItemComponent} from './user-groups-properties-item/user-groups-properties-item.component';
import {CommonModule} from '@angular/common';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NgModule} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {EffectsModule} from '@ngrx/effects';
import {UserGroupsListEffects} from './store/effects/user-groups-list.effects';
import {FilterUsersEffects} from '../core/store/effects/filter-users.effects';
import {ListUsersComponent} from './list-users/list-users.component';
import {MANAGE_GROUPS_REDUCER} from './store/reducers/feature.reducers';
import {CurrentUserGroupEffects} from './store/effects/current-user-group.effects';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

const effects_user_groups = [ UserGroupsListEffects, FilterUsersEffects, CurrentUserGroupEffects ];

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forFeature('userGroups', MANAGE_GROUPS_REDUCER),
    EffectsModule.forFeature(effects_user_groups),
    CommonModule,
    FormsModule,
    SharedModule
  ],
  declarations: [
    UserGroupsComponent,
    UserGroupsListComponent,
    UserGroupsDetailComponent,
    UserGroupsPropertiesComponent,
    UserGroupsConditionsComponent,
    UserGroupsSpecificUserComponent,
    ListUsersComponent
  ],
  exports: [
    UserGroupsComponent
  ],
  providers: [
    UserGroupsService
  ]
})
export class UserGroupsModule { }
